export class ValidatorUtils {
  static checkBOPathUrlValidity(str): boolean {
    if (!str) {
      return false;
    }
    const pattern = new RegExp('^\\/[/a-zA-Z0-9-_]+$', 'i');
    return !!pattern.test(str);
  }
}
